<template>
    <div class="payment-empty">
        <img src="../assets/images/waiting.png" width="200pt" alt="">
        <div class="text-gray1" v-html="errorMessage"></div>
    </div>
</template>

<script>
    export default {
        name: "payment-list-is-null",
        props: {
            errorMessage:{},
        },
        data() {
            return {

            }
        }
    }
</script>

<style scoped>
    .payment-empty {
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        top: 35%;
        z-index: 99;
        background: #f9f9f9;
    }
</style>